// components/common/NetworkWatcher.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setLoading } from "../../redux/action/loadingRequest";
import { useDispatch } from "react-redux";

const NetworkWatcher = ({ isOnline }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isOnline && location.pathname !== "/network-error") {
      dispatch(setLoading(false));
      navigate("/network-error", { replace: true });
    }
    if (isOnline && location.pathname === "/network-error") {
      navigate("/", { replace: true });
    }
  }, [isOnline, location.pathname, navigate]);

  return null;
};

export default NetworkWatcher;
